export default __webpack_public_path__ + "static/Badge-5b56a3ad0d185d3157e0b23770f58032.webp";